import React, { useContext } from 'react';

import { SecondaryButton } from '../../components/Button/PrimaryButton';
import { ModalContext } from '../../Context/ModalContext';

const ReportIssueBtn = () => {
  const modalContext = useContext(ModalContext);
  const onReportIssueClick = (e: any) => {
    modalContext?.displayModal(true);
  };
  return (
    <SecondaryButton arrowIcon onClick={onReportIssueClick}>
      Report Issue
    </SecondaryButton>
  );
};

export default ReportIssueBtn;
